// Overlays on small screens open just below the rendered header, so they follow its real height
// (the mobile header has two rows). Returns null when there is no header to measure.
export function headerBottomPx() {
  const header = document.querySelector('header');
  return header ? header.getBoundingClientRect().bottom : null;
}

// Inline position for a mobile overlay below the header; desktop keeps its own CSS positioning
export function mobileOverlayStyle() {
  if (window.innerWidth >= 640) return undefined;
  const top = headerBottomPx();
  return top == null ? undefined : { top, maxHeight: `calc(100vh - ${top + 16}px)` };
}
